/**
 * Frontend Sentry wrapper (F22 — FUTURE_ENHANCEMENTS).
 *
 * No-op when REACT_APP_SENTRY_DSN is unset. Init called from index.tsx
 * before React renders so React's error boundaries can flush to Sentry.
 */
import * as Sentry from '@sentry/react';

let initialised = false;

export function initSentry(): void {
  if (initialised) return;
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || 'development',
    release: process.env.REACT_APP_RELEASE_TAG || 'unknown',
    tracesSampleRate: 0.10,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    sendDefaultPii: false,
  });
  initialised = true;
  // eslint-disable-next-line no-console
  console.info('[sentry] frontend error reporting ON');
}
